import { AppRouteProps } from "@harea/component";
import React from "react";

const RolesContainer = React.lazy(() => import('./containers/MyOrganizationRolesList'))

export const RolesRoutes: Array<AppRouteProps> = [
    {
        path: 'roles',
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR", "ROLE_MANAGE"],
        title: "std_roles",
        element: <RolesContainer />
    }
]
